export const GROUPS_LIST_STRINGS = {
    NO_GROUPS_FOUND: "There are no groups to show.",
    WEB_ACCESSIBILITY_MEMBERS_IN_THE_GROUP: "Members in this group",
};

export const GROUPS_LIST_PROFILE_PHOTO_PREVIEWS_STRINGS = {
    IMAGE_ACCESSIBILITY_LABEL: "Profile photos group user thumbnails preview",
};
